import { useEffect, useState} from 'react';
import React from 'react';
import { useParams } from 'react-router-dom'
import api from '../api/dataSource';
import Swal from 'sweetalert2'
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal)

const Certificado = () => {
  const { id } = useParams()
  const [laUrl, setLaUrl] = useState('')
  const convertir = () => {
    try {
      const cadena = atob(id)
      const chars = {'v':'a', 'w':'i', 'x':'e', 'y': 'o', 'z': '/'};
      let x = cadena.replace(/[vwxyz]/g, m => chars[m])
      const baseViewer = 'http://crdascz.com/crdasczX/lib/web/viewer.html?file='
      const url = `${baseViewer}${api.baseCampeonato}${x}`
      setLaUrl(url)
    } catch (e) {
      MySwal.fire(
        'Error',
        'Error al abrir el certificado',
        'error'
      )
    }
  }

  useEffect(() => {
    convertir()
  }, [1])

  return (
    <div className="container-fluid" style={{paddingTop: '100px'}}>
      <div className="row">
        <div className="col-12">
          <iframe style={{ width: '100%', height: '900px' }} title="iframe" src={laUrl} />
        </div>
      </div>
      <br />
    </div>
  )
}

export default Certificado;
